import { render, staticRenderFns } from "./MetrcFeeSummary.vue?vue&type=template&id=2f4c9fb4&"
import script from "./MetrcFeeSummary.vue?vue&type=script&lang=js&"
export * from "./MetrcFeeSummary.vue?vue&type=script&lang=js&"
import style0 from "./MetrcFeeSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports